import React, { useEffect } from 'react';
import InfoIconComponent from '../../InfoIcon';
import style from './PositionTacticModules.module.css';
import PropTypes from 'prop-types';
import ValueListInput from '../../../../../../atomic/inputs/valueListInput/ValueListInput';
import ScalingInDocs from '../../../../documentation/ScalingInDocumentation';

function ScalingInModule({ state, top }) {
  const [scalingIn, dispatchScalingIn, , setScalingInEnabled] = state;

  const arrayToStringList = (arr) => {
    return arr.join(',');
  };

  useEffect(() => {
    setScalingInEnabled(true);
  }, []);

  return (
    <div className={style.moduleStyle}>
      <span className={style.tacticName}>
        <InfoIconComponent docs={ScalingInDocs} /> Scaling In
      </span>
      <div className={style.inputs}>
        <div className={style.inputAndLabel}>
          <p>{top.quantityBasis === 'DOLLARS' ? 'Dollar' : 'Qty.'} Amounts</p>
          <ValueListInput
            inputWidth="5em"
            direction="left"
            allowRepeats={true}
            addDecimals={top.quantityBasis === 'DOLLARS'}
            currentValues={scalingIn.quantityBasisValues || []}
            symbol={top.quantityBasis === 'DOLLARS' ? '$' : '#'}
            onAddDelete={(valueList) =>
              dispatchScalingIn({
                quantityBasisValues: arrayToStringList(valueList),
              })
            }
          />
        </div>
        <div className={style.inputAndLabel}>
          <p>Break Prices</p>
          <ValueListInput
            inputWidth="5em"
            direction="left"
            allowRepeats={true}
            addDecimals
            currentValues={scalingIn.breakPrices || []}
            symbol="$"
            onAddDelete={(valueList) =>
              dispatchScalingIn({
                breakPrices: arrayToStringList(valueList),
              })
            }
          />
        </div>
      </div>
    </div>
  );
}
ScalingInModule.propTypes = {
  state: PropTypes.array.isRequired,
  top: PropTypes.object.isRequired,
};
export default ScalingInModule;
